import { combineReducers } from 'redux';
import jobs from './jobs';
import admins from './admins';
import events from './events';
import locations from './locations';
import users from './users';
import { skillsList, skillLevels } from './skills';
import { jobCategories } from './jobCategories';
import workers from './workers';
import prospects from './prospects';
import worker from './worker';
import employers from './employers';
import companies from './companies';
import payroll from './payroll';
import { dashboard } from './dashboard';
import conversations from './conversations';
import conversationMessages from './conversationMessages';
import orientationDates from './orientationDates';
import orientations from './orientations';
import assessments from './assessments';
import ui from './ui';
import * as actionTypes from '../actions/actionTypes';

const info = (state = '', action) => {
  switch (action.type) {
    case actionTypes.SHOW_INFO:
      return action.info;
    case actionTypes.HIDE_INFO:
      return '';
    default:
      return state;
  }
};

const error = (state = '', action) => {
  switch (action.type) {
    case actionTypes.SHOW_ERROR:
      return action.error;
    case actionTypes.HIDE_ERROR:
      return '';
    default:
      return state;
  }
};

const user = (state = {}, action) => {
  switch (action.type) {
    case actionTypes.SIGN_IN:
      return { ...state, ...action.user };
    case actionTypes.LOG_OUT:
      return {};
    case actionTypes.UPDATE_USER:
      return { ...state, ...action.user };
    default:
      return state;
  }
};

const languagesList = (state = [], action) => {
  switch (action.type) {
    case actionTypes.GET_LANGUAGES_LIST_SUCCESS:
      return action.languages;
    default:
      return state;
  }
};

const reference = (state = {}, action) => {
  switch (action.type) {
    case actionTypes.REFERENCE_REQUEST:
      return { ...action.payload };
    case actionTypes.REFERENCE_SENT:
      return {};
    default:
      return state;
  }
};

const dressCodesList = (state = [], action) => {
  switch (action.type) {
    case actionTypes.GET_ALL_DRESS_CODES_SUCCESS:
      return action.dressCodes;
    default:
      return state;
  }
};

const companyLocations = (state = [], action) => {
  switch (action.type) {
    case actionTypes.SET_COMPANY_LOCATIONS:
      return action.locations;
    case actionTypes.ADD_COMPANY_LOCATION:
      return state.concat(action.data);
    default:
      return state;
  }
};

const asideMenuIsOpen = (state = false, action) => {
  switch (action.type) {
    case actionTypes.TOGGLE_ASIDE_MENU:
      return !state;
    case actionTypes.CLOSE_ASIDE_MENU:
      return false;
    default:
      return state;
  }
};

const asideMenuIsAvailable = (state = true, action) => {
  switch (action.type) {
    case actionTypes.HIDE_DESKTOP_ASIDE_MENU:
      return false;
    case actionTypes.SHOW_DESKTOP_ASIDE_MENU:
      return true;
    default:
      return state;
  }
};

export default combineReducers({
  info,
  error,
  asideMenuIsOpen,
  asideMenuIsAvailable,
  user,
  languagesList,
  skillsList,
  skillLevels,
  jobCategories,
  worker,
  employers,
  companies,
  dressCodesList,
  companyLocations,
  reference,
  jobs,
  events,
  locations,
  users,
  dashboard,
  admins,
  workers,
  prospects,
  payroll,
  conversations,
  conversationMessages,
  orientationDates,
  orientations,
  assessments,
  ui
});



// WEBPACK FOOTER //
// ./src/reducers/index.js